export enum DocumentTypeMatchingRecordAction {
  CreateNew,
  AppendPages,
  ReplaceMatchingRecordBecomesVersion,
  CreateAsVersionOfMatchingRecord,
  Overwrite
}